import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loading } from './LoadingComponent';
import { S3Uploader } from './S3UploaderComponent';
import { withRouter } from 'react-router-dom';
import { Button, Alert } from 'reactstrap';
import { postRequest } from '../redux/ActionCreators';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm
  };
};

class ClientPortLoad extends Component {
  constructor(props){
      super(props);
      this.state = {
        msg:null
      };
    this.loadPositions = this.loadPositions.bind(this);
  }
  loadPositions(data){
    const res = postRequest(data, "validate_file_wm", 0);
    return res;
  }
  
  render(){
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
    } else {

      return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
              <div className="col-auto">
                <h4>Carga de Posiciones</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
                <div className="col-6 m-2">
                    <S3Uploader
                      bucket="condor-queries"
                      dir="client_positions_external/"
                      button_label="Cargar Posiciones"
                      validator={this.loadPositions}
                      filename_var="load_params.client_filename"
                      changeModel={this.props.changeModel}
                      other_params={{
                        file_type:"client_positions", 
                        bucket_output:"condor-sura-wm", 
                        prefix_path:`client_positions_external/client=${this.props.user_wm.data.organization}`,
                        cty:this.props.user_wm.data.country
                      }}
                    />
                </div>
            </div>
          </div>
      );
    }
  }
}

export default withRouter(connect(mapStateToProps)(ClientPortLoad));
